import { defineComponent as _defineComponent } from 'vue'
import {
  useI18n,
} from "@/composables/useI18n";

import {
  onMounted,
  PropType,
  ref,
  unref,
} from "vue";

import FloatingActionButton from "@/components/buttons/FloatingActionButton.vue";

import ConfirmationDialog from "@/components/base/ConfirmationDialog.vue";

import {
  CardUser,
} from "@/components/cardUsers/scripts/types";

import {
  deleteCardUser,
  fetchCardUsers,
  CARD_USER_ID_STORAGE_KEY,
} from "@/components/cardUsers/scripts";

import {
  useDataTableDefaults,
} from "@/composables/useDataTableDefaults";

import {
  saveItemToStorage,
} from "@/scripts/Common/componentStorage";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardUserManagement',
  props: {
  hasEditRights: {
    required: true,
    type: Boolean as PropType<boolean>,
  }
},
  emits: [
  'onSelectCardUserDetail',
  'onCreateNewCardUser',
  'onFetchError'
],
  setup(__props, { emit: emits }) {

const props = __props;

const {
  t,
} = useI18n();

const {
  pagination,
  dataTableFooter,
} = useDataTableDefaults();





const users = ref<CardUser[]>([]);
const selectedUserId = ref<number>(0);

const deleteUserDialog = ref();
const search = ref<string>("");

const hasNoEditRights = !props.hasEditRights;

const headers = [
  {
    value: "actions",
    sortable: false,
    width: "1%"
  },
  {
    align: "start",
    filterable: false,
    text: t("user_first_name"),
    value: "firstName"
  },
  {
    align: "start",
    filterable: true,
    text: t("user_last_name"),
    value: "lastName"
  },
  {
    align: "start",
    filterable: false,
    text: t("user_phone_number"),
    value: "phoneNumber"
  },
  {
    align: "start",
    filterable: false,
    text: t("user_mail"),
    value: "email"
  },
  {
    align: "start",
    filterable: true,
    text: t("user_paycard_number"),
    value: "paycardNumber"
  },
  {
    align: "start",
    text: t("user_action"),
    filterable: false,
    value: "edit"
  }
];

const createNewCardUser = () => {
  emits('onCreateNewCardUser');
}

const onSelectCardUserDetails = (id: number) => {
  saveItemToStorage(id, CARD_USER_ID_STORAGE_KEY);
  emits('onSelectCardUserDetail');
};

const onHandleDeleteCardUser = (userId: number) => {
  selectedUserId.value = userId;
  deleteUserDialog.value.Show();
}

const onHandleFetchError = ({error}: { error: any }) => {
  emits('onFetchError', {error})
};

const loadCardUsers = async () => {
  const {response, error} = await fetchCardUsers();

  if (error || !response) {
    onHandleFetchError({error});
    return;
  }

  users.value = response;
  pagination.value.totalItemCount = users.value.length ?? 0;
}

const onDeleteCardUser = async () => {
  if (!selectedUserId) return;

  const {error} = await deleteCardUser(unref(selectedUserId));

  if (error) {
    onHandleFetchError({error})
    return;
  }

  loadCardUsers();
}


onMounted(() => {
  loadCardUsers();
});

return { __sfc: true,t, pagination, dataTableFooter, props, emits, users, selectedUserId, deleteUserDialog, search, hasNoEditRights, headers, createNewCardUser, onSelectCardUserDetails, onHandleDeleteCardUser, onHandleFetchError, loadCardUsers, onDeleteCardUser, FloatingActionButton, ConfirmationDialog }
}

})